import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import moment from 'moment';

type Obj = { [key: string]: any };

type ErrorMessages = {
  mandatory?: string;
};
type State = {
  values: Obj;
  defaultValues: Obj;
  error: Record<string, any>;
  errorMessages: Record<string, ErrorMessages>; // custom error messages for each input, setup from canvas
  inputError: Record<string, string>;
  formValue: Record<string, any>;
  inputIdFocus?: string;
};

const initialState: State = {
  values: {},
  defaultValues: {},
  error: {
    message: '',
    isError: false,
  },
  errorMessages: {},
  inputError: {},
  formValue: {},
  inputIdFocus: undefined,
};

const fromInputSlice = createSlice({
  name: 'formInput',
  initialState: initialState,
  reducers: {
    setDefaultValues: (state: State, action: PayloadAction<Obj>) => {
      return {
        ...state,
        defaultValues: {
          ...state.defaultValues,
          ...action.payload,
        },
      };
    },
    setDefaultValueInput: (state: State, action: PayloadAction<Obj>) => {
      return {
        ...state,
        defaultValues: {
          ...state.defaultValues,
          ...action.payload,
        },
        values: {
          ...state.values,
          ...action.payload,
        },
      };
    },
    resetValue: (state: State, action: PayloadAction<Obj>) => {
      let newState = { ...state, values: { ...state.values } };
      let arrId = Object.keys(action.payload);
      for (let i = 0; i < arrId.length; i++) {
        const key = arrId[i];
        // TODO: MIK-3844: do not reset value if current-value is date picker
        // const isDateValue =
        //   newState.values[key] && newState.defaultValues[key]
        //     ? moment(newState.defaultValues[key]).isValid()
        //     : false;
        // if (isDateValue) {
        //   continue;
        // }
        const defaultValue = newState.defaultValues[key];
        // `isEmpty` reports `true` for booleans, which would drop the default of
        // a boolean input (Switch / Toggle) on reset instead of restoring it.
        if (typeof defaultValue === 'boolean' || !isEmpty(defaultValue)) {
          newState.values[key] = defaultValue;
        } else {
          delete newState.values[key];
        }
      }
      return newState;
    },
    resetAllValue: (state: State) => {
      state.defaultValues = {};
      state.values = {};
    },
    setValueInput: (state: State, action: PayloadAction<any>) => {
      return {
        ...state,
        values: {
          ...state.values,
          ...action.payload,
        },
      };
    },
    setError: (state: State, action: PayloadAction<any>) => {
      state.error = {
        message: action.payload.message,
        isError: true,
      };
    },
    resetError: (state: State) => {
      state.error = initialState.error;
    },
    setFormValue: (state: State, action: PayloadAction<any>) => {
      return {
        ...state,
        formValue: {
          ...state.formValue,
          ...action.payload,
        },
      };
    },
    resetValueForm: (state: State, action: PayloadAction<Obj>) => {
      let newState = { ...state, formValue: { ...state.formValue } };
      let arrId = Object.keys(action.payload);
      for (let i = 0; i < arrId.length; i++) {
        delete newState.formValue[arrId[i]];
      }
      return newState;
    },
    focusInput: (state: State, action: PayloadAction<{ inputId: string }>) => {
      const { inputId } = action.payload;
      state.inputIdFocus = inputId;
      return state;
    },
    setDefaultErrorMessages: (state: State, action: PayloadAction<Obj>) => {
      return {
        ...state,
        errorMessages: {
          ...state.errorMessages,
          ...action.payload,
        },
      };
    },
    clearValueInputError: (state: State) => {
      return {
        ...state,
        inputError: initialState.inputError,
      };
    },
    setValueInputError: (state: State, action: PayloadAction<Obj>) => {
      return {
        ...state,
        inputError: {
          ...action.payload,
        },
      };
    },
  },
});
export const {
  setDefaultValues,
  setDefaultValueInput,
  resetValue,
  setValueInput,
  resetAllValue,
  setError,
  resetError,
  setFormValue,
  resetValueForm,
  focusInput,
  setDefaultErrorMessages,
  setValueInputError,
  clearValueInputError,
} = fromInputSlice.actions;

export default fromInputSlice.reducer;
